export enum MediaSourceType {
    aac = 'aac',
    mp4 = 'mp4',
    f4v = 'f4v',
    m4v = 'm4v',
    mov = 'mov',
    mp3 = 'mp3',
    mpeg = 'mpeg',
    ogv = 'ogv',
    ogg = 'ogg',
    oga = 'oga',
    vorbis = 'vorbis',
    webm = 'webm',
    f4a = 'f4a',
    m3u8 = 'm3u8',
    m3u = 'm3u',
    hls = 'hls',
    dash = 'dash'
}
